export type UserData = {
  hash: string;
  created: string;
  modified: string;
};

export enum TLD {
  DE = 'de',
  FR = 'fr',
  NL = 'nl',
}
